import { configureStore } from "@reduxjs/toolkit";
import userDataReducer from "./userDataSlice";
import languageReducer from "./LanguageSlice";
import menuReducer from "./MenuSlice";
import loaderReducer from "./LoaderSlice";
export var store = configureStore({ reducer: { userData: userDataReducer, language: languageReducer, menuOpen: menuReducer, loader: loaderReducer } });
